<template>
  <div>
    <div class="container-fluid p-0">
      <!-- <h2 class="heading">fiifi</h2>
      <div class="row" style="width:100%">
        <div
          class="col-xl-8 col-lg-7 col-md-6 d-sm-none d-none d-md-block bckGrdImg default-transition"
        ></div>
        <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12 default-transition">
          <div v-if="!isSigup" class="trnsCls">
            <h3 class="wlcmTxt">Signup</h3>
            <b-alert
              :show="message.length>0?true:false"
              :variant="variant"
              dismissible
              @dismissed="message=''"
            >{{message}}</b-alert>
            <form autocomplete="off" @submit.prevent="signupSubmit">
              
              <span class="forgtTxt" style="float:left;">Full Name</span>
              <input
                type="text"
                class="form-control inputGapCls"
                v-model="signupForm.full_name"
                required
                placeholder="Enter Full Name"
              />
              
              <span class="forgtTxt" style="float:left;">Email</span>
              <input
                type="email"
                class="form-control inputGapCls"
                v-model="signupForm.email"
                required
                placeholder="Enter Email"
              />
              <span class="forgtTxt" style="float:left;">Password</span>
              <input
                type="password"
                class="form-control inputGapCls"
                v-model="signupForm.pswd"
                required
                @keyup="passwordValidation"
                placeholder="Enter password"
              />
              <small
                class="text-danger"
                v-if="!valid"
              >Password must be minimum of 8 characters, it should be alpha numeric and have at least one special character.</small>
              <div class="row" style="margin-top: 5%;">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <button type="submit" :disabled="!valid || isSubmit" class="lgnBtn">
                    Sign up
                    <b-spinner v-if="isSubmit" style="float: right;" small label="Loading..."></b-spinner>
                  </button>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <button class="crtAcntBtn" type="button" @click="login">Login</button>
                </div>
              </div>
              <div class="row">
                
                <span style="margin-left:6%;margin-top:3%">Or Continue with</span>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12">
                 
                  <a :href="googleUrl">
                    <img src="static/img/google-icon.png" class="lgnIcns" />
                  </a>
                  <a :href="linkedinUrl">
                    <img src="static/img/link-icon.png" class="lgnIcns" />
                  </a>
                  <a :href="twitterUrl">
                    <img src="static/img/twitter-icon.png" class="lgnIcns" />
                  </a>
                </div>
              </div>
            </form>
          </div>
          <div v-else class="trnsCls verifyCls">
            <i class="fa fa-check-circle chkCircle"></i>
            <div>
              <h4 class="card-title" style="color: #FFFFFF;">Congrats! Sign-up is successful.</h4>
              <h5 class="card-text textLink">
                We have sent you a verification email.
                Please verify your email and sign-in
              </h5>
              <button class="crtAcntBtn" @click="login">Login</button>
            </div>
          </div>
        </div>
        <div class="col-sm-5 col-0"></div>
      </div>-->
      <div class="loginBackgroundImage" style="min-height:100vh;height:auto">
        <div class="row m-0 p-0" style="width:100%;padding-top:30px">
          <div
            class="row mr-0 ml-0 d-flex justify-content-center w-100"
            style="margin-top: 60px;margin-bottom: 30px;"
          >
            <div class="heading">fiifi</div>
          </div>
          <div class="col-12 d-flex justify-content-center align-items-center">
            <div class="loginPopup" v-if="!isSigup">
              <div class="loginPopupLayout">
                <div>
                  <div class="loginTitle">Sign Up</div>
                  <b-alert
                    :show="message.length>0?true:false"
                    :variant="variant"
                    dismissible
                    @dismissed="message=''"
                  >{{message}}</b-alert>
                  <div>
                    <form
                      autocomplete="off"
                      @submit.prevent="signupSubmit"
                      style="margin-bottom:37px;"
                    >
                      <span class="forgtTxt" style="float:left;">Full Name</span>
                      <input
                        type="text"
                        class="form-control inputSignUpWrapper"
                        v-model="signupForm.full_name"
                        required
                        placeholder="Enter Full Name"
                      />
                      <span class="forgtTxt" style="float:left;">Email</span>
                      <input
                        type="email"
                        class="form-control inputSignUpWrapper"
                        v-model="signupForm.email"
                        required
                        placeholder="Enter Email"
                      />
                      <span class="forgtTxt" style="float:left;">Password</span>
                      <input
                        type="password"
                        class="form-control inputSignUpWrapper"
                        v-model="signupForm.pswd"
                        required
                        @keyup="passwordValidation"
                        placeholder="Enter Password"
                        style="margin-bottom:20px"
                      />
                      <div v-if="!valid" style="padding-bottom:20px">
                        <small
                          class="text-danger"
                        >Password must be minimum of 8 characters, it should be alphanumeric and have at least one uppercase and one special character.</small>
                      </div>
                      <div class="d-flex" style>
                        <div class="flex-grow-1"></div>
                        <div>
                          <button
                            type="submit"
                            :disabled="!valid || isSubmit"
                            class="todo-form-submit-button btn btn-primary mb-0"
                          >
                            Sign Up
                            <b-spinner
                              v-if="isSubmit"
                              style="float: right;"
                              small
                              label="Loading..."
                            ></b-spinner>
                          </button>
                        </div>
                      </div>
                    </form>
                    <div class="loginAboveIconsText">Or you can Sign Up with</div>
                    <div class="d-flex justify-content-center" style="margin-top:17px">
                      <div style="margin-right:17px;margin-top: 3px;">
                        <a :href="googleUrl">
                          <img src="static/img/google-icon.png" class />
                        </a>
                      </div>
                      <div style="margin-right:17px">
                        <a :href="linkedinUrl">
                          <img src="static/img/link-icon.png" class />
                        </a>
                      </div>
                      <div style="margin-right:17px">
                        <a :href="twitterUrl">
                          <img src="static/img/twitter-icon.png" class />
                        </a>
                      </div>
                      <div class="ltseBtnDiv">
                        <a :href="ltseUrl">
                          <img src="static/img/ltse.png" class="suggestImage" />
                        </a>
                      </div>
                    </div>
                    <div style="margin-top:17px">
                      <div class="newToFiifi">
                        Already on fiifi?
                        <span
                          style="color:#5445F3;cursor:pointer;"
                          @click="login"
                        >Login</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div v-else class="trnsCls verifyCls">
                  <i class="fa fa-check-circle chkCircle"></i>
                  <div>
                    <h4 class="card-title" style="color: #FFFFFF;">Congrats! Sign-up is successful.</h4>
                    <h5 class="card-text textLink">
                      We have sent you a verification email.
                      Please verify your email and sign-in
                    </h5>
                    <button class="crtAcntBtn" @click="login">Login</button>
                  </div>
                </div>-->
              </div>
            </div>
            <div v-else class="trnsCls verifyCls">
              <i class="fa fa-check-circle chkCircle"></i>
              <div>
                <h4 class="card-title" style="color: #FFFFFF;">Congrats! Sign-up is successful.</h4>
                <h5 class="card-text textLink">
                  We have sent you a verification email.
                  Please verify your email and sign-in
                </h5>
                <button class="crtAcntBtn" @click="login">Login</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthLayout from "./AuthLayout.vue";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import config from "../../../../config/settings";

export default {
  components: {
    AuthLayout,
  },
  computed: {
    ...mapGetters("user", ["token", "user"]),
  },
  data() {
    return {
      modals: {
        custom: false,
        dataimport: false,
      },
      luser: {
        email: "",
        password: "",
      },
      valid: false,
      variant: "",
      message: false,
      signupForm: {},
      code: "",
      userName: "",
      isSigup: false,
      isSubmit: false,
      facebookUrl: "",
      googleUrl: "",
      twitterUrl: "",
      linkedinUrl: "",
      ltseUrl: "",
      flagRequestOnce: false,
    };
  },
  mounted() {
    if (this.$route.query.per) {
      if (this.$route.query.a) {
        window.localStorage.setItem(
          "share-portfolio-referred",
          this.$route.query.a
        );
      }
      window.localStorage.setItem(
        "share-portfolio-permalink",
        this.$route.query.per
      );
      this.$router.push(`/signup`);
    }
    if (this.$route.query.plan) {
      window.localStorage.setItem("plan", this.$route.query.plan);
      this.$router.push(`/signup`);
    }
    this.facebookUrl = `//${config.URL}/api/auth/facebook`;
    this.googleUrl = `//${config.URL}/api/auth/google`;
    this.twitterUrl = `//${config.URL}/api/auth/twitter`;
    this.linkedinUrl = `//${config.URL}/api/auth/linkedin`;
    this.ltseUrl = `//${config.URL}/api/auth/ltse`;
    // attach window message listener
    if (window.addEventListener) {
      window.addEventListener("message", this.handleMessage.bind(this), false);
    } else {
      window.attachEvent("onmessage", this.handleMessage.bind(this));
    }
    // check to see if we can just refresh
    if (this.$store.getters["user/hasToken"]) {
      // logout for now
      this.logout();
    }
    this.flagRequestOnce = false;
  },
  methods: {
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    login(e) {
      e.preventDefault();
      this.$router.push("/login");
    },
    passwordValidation() {
      let data = this.checkPassword(this.signupForm.pswd);
      if (data && this.signupForm.email) this.valid = true;
      else this.valid = false;
    },
    checkPassword(str) {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
    },
    signupSubmit(e) {
      e.preventDefault();
      this.isSubmit = true;
      let full_name = this.signupForm.full_name.trim();
      if (full_name.length <= 0) {
        this.$toaster.error("Please provide valid Inputs.");
        this.isSubmit = false;
        this.signupForm.full_name = "";
        return;
      }
      let email = this.signupForm.email.toLowerCase();
      api
        .post(`/cognito/check/email?email=${email}`)
        .then((data) => {
          if (
            data &&
            data.data &&
            data.data.encrypt &&
            data.data.encrypt.fail &&
            data.data.encrypt.fail.length > 0
          ) {
            this.$toaster.error("Email already exist.");
            this.isSubmit = false;
            return;
          } else {
            let full_name = this.signupForm.full_name.trim();
            full_name = full_name.split(" ");
            let firstname = full_name[0];
            let lastname = "";
            if (full_name.length > 1) {
              full_name.map((item, index) => {
                if (index > 0) lastname += item + " ";
                return item;
              });
              lastname = lastname.trim();
            }
            let fname =
              full_name[0].length > 3
                ? full_name[0].substring(0, 3)
                : full_name[0];
            fname = fname + new Date().valueOf();
            let lname;
            if (full_name.length > 1) {
              lname =
                full_name[1].length > 3
                  ? full_name[1].substring(0, 3)
                  : full_name[1];
              lname = lname + new Date().valueOf();
            }
            let userName = "";
            if (fname && lname) {
              userName = fname + "_" + lname;
            } else if (fname) {
              userName = fname;
            }
            this.$Amplify.Auth.signUp({
              username: userName,
              email: email,
              password: this.signupForm.pswd,
              attributes: {
                name: `${firstname} ${lastname}`,
                given_name: `${firstname} ${lastname}`,
                email: email,
              },
            })
              .then((data) => {
                this.isSigup = true;
                this.isSubmit = false;
                this.valid = true;
                this.signupForm = {};
              })
              .catch((err) => {
                this.variant = "danger";
                this.isSubmit = false;
                this.valid = true;
                this.message =
                  err.message.includes("validation") &&
                  err.message.includes("username")
                    ? "Please enter valid username"
                    : err.message;
              });
          }
        })
        .catch((err) => {
          this.variant = "danger";
          this.isSubmit = false;
          this.valid = true;
          this.message = "Unable to process your request..Please try again.";
          console.log({ err });
        });
    },
  },
};
</script>
<style scoped>
.chkCircle {
  font-size: 5em;
  color: gainsboro;
  text-align: center;
  margin-left: 39%;
}
.textLink {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
  color: white;
  padding: 22px;
}

.verifyCls {
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  background: no-repeat padding-box #5445f3;
}
</style>
<style>
.inputSignUpWrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000000;
  border: 1px solid #2e2e2e !important;
  border-radius: 5px;
  opacity: 1;
}
.inputSignUpWrapper:focus {
  border: 1px solid #5445f3 !important;
}
</style>